module.exports = __webpack_public_path__ + "d431b9b730240a3645a5f51aac42f056.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fossil-fuels-chart.png
// module id = 1954
// module chunks = 0